import React from 'react';
import { noop, startCase } from 'lodash';

import type { ActionFooterProps } from '~/components/AiChat/SideBarDialog/Actions/Action/ActionTypes';
import { DismissButton } from '~/components/AiChat/SideBarDialog/Actions/Action/DismissButton';
import { ExecuteButton } from '~/components/AiChat/SideBarDialog/Actions/Action/ExecuteButton';
import { hasActionPreview } from '~/components/AiChat/SideBarDialog/Actions/Action/ReviewAndExecute/ActionPreview';
import { ActionPreviewButton } from '~/components/AiChat/SideBarDialog/Actions/Action/ReviewAndExecute/ActionPreviewButton';
import { SuggestedActionReviewDialog } from '~/components/AiChat/SideBarDialog/Actions/Action/ReviewAndExecute/SuggestedActionReviewDialog';
import mixpanel from '~/components/CmsMain/mixpanel';
import { CLIVE_MIXPANEL_EVENTS } from '~/pocs/mixpanel';

export const ReviewAndExecuteFooter: React.FC<ActionFooterProps> = ({
  onExecute = noop,
  onDismiss = noop,
  isDone,
  type,
  action,
  isDemo = false,
  dismissLabel,
  title,
  subtitle,
}) => {
  const [isReviewOpen, setIsReviewOpen] = React.useState(false);

  const handleOpenReview = () => {
    mixpanel.track(CLIVE_MIXPANEL_EVENTS.ACTION_OPEN_CLICKED, { type, is_done: isDone, isDemo });
    setIsReviewOpen(true);
  };

  const handleConfirm = () => {
    setIsReviewOpen(false);
    onExecute();
  };

  return (
    <div className="flex items-center justify-between">
      <DismissButton onDismiss={onDismiss} disabled={isDone} label={dismissLabel} />
      <ExecuteButton onExecute={handleOpenReview} isDone={isDone} />
      {hasActionPreview(action) ? (
        <ActionPreviewButton
          className="ml-8"
          action={action}
          title={title || startCase(type)}
          subtitle={subtitle}
          isDone={isDone}
        />
      ) : null}

      {isReviewOpen ? (
        <SuggestedActionReviewDialog
          action={action}
          title={title || startCase(type)}
          subtitle={subtitle}
          onConfirm={handleConfirm}
          onClose={() => setIsReviewOpen(false)}
        />
      ) : null}
    </div>
  );
};
